import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import { createBrowserHistory } from 'history'
import configureStore from 'store'
import * as serviceWorker from './serviceWorker'
import 'url-search-params-polyfill'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import nprogress from 'nprogress'
import { initAliFingerprint } from 'utils/initAliFingerprint'

// Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBLp7AJvA5uOfawH5f1zQkc8P91HLqMU1U',
  authDomain: 'gateway-e0bb8.firebaseapp.com',
  projectId: 'gateway-e0bb8',
  storageBucket: 'gateway-e0bb8.appspot.com',
  messagingSenderId: '611067182877',
  appId: '1:611067182877:web:e3ebf7e53d4041652cebf4',
  measurementId: 'G-0QDCBNC17P',
}

const LEGACY_FINGERPRINT_KEYS = ['x-device-id', 'x-cko-device-id']

function clearLegacyFingerprintCache() {
  LEGACY_FINGERPRINT_KEYS.forEach((key) => sessionStorage.removeItem(key))
}

/**
 * Initialize Ali fingerprinting and security features
 * @returns {Promise} Promise that resolves when all security features are initialized
 */
async function initializeSecurity() {
  clearLegacyFingerprintCache()
  return Promise.allSettled([
    initAliFingerprint(),
  ])
}

/**
 * Initialize Firebase analytics
 * @returns {Object} Firebase analytics instance
 */
function initializeAnalytics() {
  const app = initializeApp(firebaseConfig)
  return getAnalytics(app)
}

/**
 * Initialize Redux store and history
 * @returns {Object} Object containing store and history
 */
function initializeStore() {
  const history = createBrowserHistory()
  const store = configureStore({}, history)
  return { store, history }
}

/**
 * Render the React application
 * @param {Object} store - Redux store
 * @param {Object} history - Browser history instance
 */
function renderApp(store, history) {
  ReactDOM.render(
    <Provider store={store}>
      <App history={history} />
    </Provider>,
    document.getElementById('root')
  )
}

/**
 * Bootstrap the application
 * Initializes security features, analytics, and renders the app
 */
async function bootstrapApplication() {
  // Start progress indicator
  nprogress.start()
  const preLoadingEle = document.getElementById('pre-loading')

  try {
    // Initialize security features before the first API request.
    await initializeSecurity()

    // Remove loading indicator
    nprogress.done()
    if (preLoadingEle) {
      preLoadingEle.remove()
    }

    // Initialize analytics
    window.analytics = initializeAnalytics()

    // Initialize store and history
    const { store, history } = initializeStore()
    window.appStore = store

    // Render the application
    renderApp(store, history)
  } catch (error) {
    console.error('Error during application bootstrap:', error)
    nprogress.done()
    if (preLoadingEle) {
      preLoadingEle.remove()
    }
    // Render error state or fallback UI if needed
  }
}

// Start the application
bootstrapApplication()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
